import {
  CheckCircle,
  CheckCircleOutline,
  DragIndicator,
} from "@material-ui/icons";
import React, { Component } from "react";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import { Button, Col, Row } from "react-bootstrap";
import { connect } from "react-redux";
import { getAllContigencyAction } from "../../../actions/MasterTemplateActions";

var _ = require("lodash");

const reorder = (list, startIndex, endIndex) => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);
  return result;
};

const getItemStyle = (isDragging, draggableStyle) => ({
  userSelect: "none",
  background: isDragging ? "#f5f9fc" : "",
  ...draggableStyle
});

const getListStyle = isDraggingOver => ({
  background: isDraggingOver ? "#fff" : ""
});

class Contingencies extends Component {
  constructor(props) {
    super(props);

    this.state = {
      activeContigency: true,
      items: [],
      isvendorClick: false,
      allContingencies: [],
      allContingenciesFromAPI: [],
      showLoader: true
    };
    this.onDragEnd = this.onDragEnd.bind(this);
  }

  onDragEnd(result) {
    if (!result.destination) {
      return;
    }
    const items = reorder(
      this.state.items,
      result.source.index,
      result.destination.index
    );
    this.setState({
      items
    });
  }


  /**
   * @desc active/de-active contigency
   */
  activeContigency(i, index, item) {
    let currentContingencie = this.state.allContingencies;

    let isActive = true;
    if (i == 1) {
      isActive = false;
    }

    for (let j = 0; j < currentContingencie.length; j++) {
      if (currentContingencie[j].key === item.key) {
        // currentContingencie.push({
        //   isActive: currentContingencie[j].isActive
        // })
        currentContingencie[j].isActive = isActive;
      }
    }

    this.setState({ allContingencies: currentContingencie });
    let contiObj = [];
    for (let i = 0; i < currentContingencie.length; i++) {
      if (currentContingencie[i].isActive === true) {
        contiObj.push({
          key: currentContingencie[i].key,
          name: currentContingencie[i].key,
          val: currentContingencie[i].val,
          isActive: currentContingencie[i].isActive,
          isParticipant: currentContingencie[i].isParticipant
        })
      }
    }

    this.props.setFieldValue("contingencies", contiObj);
  }

  componentWillMount() {
    let contingencies = [];
    for (var key in this.props.contingencies) {
      if (this.props.contingencies.hasOwnProperty(key)) {
        contingencies.push({
          key: this.props.contingencies[key].name,
          name: this.props.contingencies[key].name,
          val: this.props.contingencies[key].val,
          isParticipant: Boolean(this.props.contingencies[key].isParticipant),
          isActive: true
        });
      }
    }
    //get all contigencies
    this.props.getAllContigencyAction().then(res => {
      res.forEach(ele => {
        var found = false;
        for (var key in this.props.contingencies) {
          if (ele.name == this.props.contingencies[key].name) {
            found = true;
          }
        }
        if (!found) {
          contingencies.push({ key: ele.name, val: ele.val, isParticipant: ele.isParticipant, isActive: false });
        }
      });
      this.setState({
        allContingencies: contingencies,
        allContingenciesFromAPI: res
      });
    });
  }

  /**
   * @desc if contigencies get changed
   */
  componentWillReceiveProps(nextProps) {
    let contingencies = [];
    for (var key in nextProps.contingencies) {
      if (nextProps.contingencies.hasOwnProperty(key)) {
        contingencies.push({
          key: nextProps.contingencies[key].name,
          name: nextProps.contingencies[key].name,
          val: nextProps.contingencies[key].val,
          isParticipant: Boolean(nextProps.contingencies[key].isParticipant),
          isActive: true
        });
      }
    }

    if (contingencies.length > 0) {
      this.state.allContingenciesFromAPI.forEach(ele => {
        var found = false;
        for (var key in nextProps.contingencies) {
          if (ele.name == nextProps.contingencies[key].name) {
            found = true;
          }
        }
        if (!found) {
          contingencies.push({ key: ele.name, val: ele.val, isParticipant: ele.isParticipant, isActive: false });
        }
      });

      this.setState({ allContingencies: contingencies, isvendorClick: false });
    } else {
      this.state.allContingenciesFromAPI.forEach(ele => {
        contingencies.push({ key: ele.name, val: ele.val, isParticipant: ele.isParticipant, isActive: false });
      });

      this.setState({ allContingencies: contingencies, isvendorClick: false });
    }
  }

  /**
   * @desc add custom contigency by input
   */
  addCustomContingency(e) {
    let newConti = "";
    if (e.key === "Enter" && e.shiftKey === true) {
      newConti = e.target.value;
    } else if (e.key === "Enter" && e.shiftKey === false) {
      newConti = e.target.value;
    }

    if (newConti !== "" && newConti !== null) {
      let currentContingencie = this.state.allContingencies;
      currentContingencie.push({ key: newConti, val: newConti, date: "", isParticipant: false, isActive: true });
      this.setState({ allContingencies: currentContingencie });

      let contiObj = [];
      for (let i = 0; i < currentContingencie.length; i++) {
        if (currentContingencie[i].isActive === true) {
          contiObj.push({
            key: currentContingencie[i].key,
            name: currentContingencie[i].key,
            val: currentContingencie[i].val,
            isActive: currentContingencie[i].isActive,
            isParticipant: currentContingencie[i].isParticipant
          })
          // contiObj[currentContingencie[i].key] = currentContingencie[i].val;
        }
      }
      if (this.props.isMasterTemplate) {
        this.props.setFieldValue("contingencies", contiObj);
      }

      e.target.value = "";
    }
  }

  /**
  * @desc add custom contigency by input
  */
  addCustomParticipant(e) {
    let newConti = "";
    if (e.key === "Enter" && e.shiftKey === true) {
      newConti = e.target.value;
    } else if (e.key === "Enter" && e.shiftKey === false) {
      newConti = e.target.value;
    }
  
    if (newConti !== "" && newConti !== null) {
      let currentContingencie = this.state.allContingencies;
      currentContingencie.push({ key: newConti, val: newConti, date: "", isParticipant: true, isActive: true });
      this.setState({ allContingencies: currentContingencie });
  
      let contiObj = [];
      for (let i = 0; i < currentContingencie.length; i++) {
        if (currentContingencie[i].isActive === true) {
          contiObj.push({
            key: currentContingencie[i].key,
            name: currentContingencie[i].key,
            val: currentContingencie[i].val,
            isActive: currentContingencie[i].isActive,
            isParticipant: currentContingencie[i].isParticipant
          })
          // contiObj[currentContingencie[i].key] = currentContingencie[i].val;
        }
      }
      if (this.props.isMasterTemplate) {
        this.props.setFieldValue("contingencies", contiObj);
      }
  
      e.target.value = "";
    }
  }

  /**
   * @desc render master template campaign
   */
  renderMasterTemplateCamp() {
    let contiAll = this.state.allContingencies;
    contiAll = _.sortBy(contiAll, "key");

    return (
      <div className="set-contingencies">
        <Row className="mt-2 align-items-center conti-title">
          <Col className="col-auto pr-0">
            <h2 className="color-blue-3 font-20 mb-2">Participants</h2>
          </Col>         
        </Row>
        <div className="set-contingencies-header">
          <ul className="set-contingencies-row">
            <li className="id"></li>
            <li className="status">Active/Inactive</li>
            <li className="title">Participant Name</li>
          </ul>
        </div>
        <div className="set-contingencies-body">
          <DragDropContext onDragEnd={this.onDragEnd}>
            <Droppable droppableId="droppable123">
              {(provided, snapshot) => (
                <div
                  {...provided.droppableProps}
                  ref={provided.innerRef}
                  style={getListStyle(snapshot.isDraggingOver)}
                >
                  {contiAll
                  .filter(contiAll => contiAll.isParticipant === true)
                  .map((item, index) => (
                    <Draggable
                      key={index}
                      draggableId={"draggableId" + index}
                      index={index}
                      isDragDisabled={true}
                    >
                      {(provided, snapshot) => (
                        <div
                          ref={provided.innerRef}
                          {...provided.draggableProps}
                          {...provided.dragHandleProps}
                          style={getItemStyle(
                            snapshot.isDragging,
                            provided.draggableProps.style
                          )}
                        >
                          <ul
                            className={
                              item.isActive
                                ? " set-contingencies-row"
                                : "inactive set-contingencies-row"
                            }
                          >
                            <li className="id">
                              <DragIndicator />
                            </li>
                            <li className="status">
                              <Button variant="transparent">
                                {item.isActive ? (
                                  <CheckCircle
                                    className="check"
                                    onClick={() =>
                                      this.activeContigency(1, item.key, item)
                                    }
                                  />
                                ) : (
                                  <CheckCircleOutline
                                    className="check-out"
                                    onClick={() =>
                                      this.activeContigency(0, item.key, item)
                                    }
                                  />
                                )}
                              </Button>
                            </li>
                            <li className="title">{item.key}</li>
                          </ul>
                        </div>
                      )}
                    </Draggable>
                  ))}
                  {provided.placeholder}
                </div>
              )}
            </Droppable>
          </DragDropContext>
        </div>

        {/* <div className="set-contingencies-footer">
          <ul className="set-contingencies-row">
            <li className="id"></li>
            <li className="status"></li>
            <li className="title">
              <input
                type="text"
                onKeyDown={e => this.addCustomParticipant(e)}
                className="form-control form-control-sm field_ucfirst"
                placeholder="Add custom participant"
              />
            </li>
          </ul>
        </div> */}

        <Row className="mt-2 align-items-center conti-title">
          <Col className="col-auto pr-0">
            <h2 className="color-blue-3 font-20 mb-2 mt-4">Contingencies</h2>
          </Col>         
        </Row>
        <div className="set-contingencies-header">
          <ul className="set-contingencies-row">
            <li className="id"></li>
            <li className="status">Active/Inactive</li>
            <li className="title">Contingency Name</li>
          </ul>
        </div>
        <div className="set-contingencies-body">
          <DragDropContext onDragEnd={this.onDragEnd}>
            <Droppable droppableId="droppable123">
              {(provided, snapshot) => (
                <div
                  {...provided.droppableProps}
                  ref={provided.innerRef}
                  style={getListStyle(snapshot.isDraggingOver)}
                >
                  {contiAll
                  .filter(contiAll => contiAll.isParticipant === false)
                  .map((item, index) => (
                    <Draggable
                      key={index}
                      draggableId={"draggableId" + index}
                      index={index}
                      isDragDisabled={true}
                    >
                      {(provided, snapshot) => (
                        <div
                          ref={provided.innerRef}
                          {...provided.draggableProps}
                          {...provided.dragHandleProps}
                          style={getItemStyle(
                            snapshot.isDragging,
                            provided.draggableProps.style
                          )}
                        >
                          <ul
                            className={
                              item.isActive
                                ? " set-contingencies-row"
                                : "inactive set-contingencies-row"
                            }
                          >
                            <li className="id">
                              <DragIndicator />
                            </li>
                            <li className="status">
                              <Button variant="transparent">
                                {item.isActive ? (
                                  <CheckCircle
                                    className="check"
                                    onClick={() =>
                                      this.activeContigency(1, item.key, item)
                                    }
                                  />
                                ) : (
                                  <CheckCircleOutline
                                    className="check-out"
                                    onClick={() =>
                                      this.activeContigency(0, item.key, item)
                                    }
                                  />
                                )}
                              </Button>
                            </li>
                            <li className="title">{item.key}</li>
                          </ul>
                        </div>
                      )}
                    </Draggable>
                  ))}
                  {provided.placeholder}
                </div>
              )}
            </Droppable>
          </DragDropContext>
        </div>

        {/* <div className="set-contingencies-footer">
          <ul className="set-contingencies-row">
            <li className="id"></li>
            <li className="status"></li>
            <li className="title">
              <input
                type="text"
                onKeyDown={e => this.addCustomContingency(e)}
                className="form-control form-control-sm field_ucfirst"
                placeholder="Add custom contingency"
              />
            </li>
          </ul>
        </div> */}
      </div>
    );
  }

  componentDidUpdate() {
    if(this.state.showLoader){
      this.setState({showLoader: false})
    }    
  }
  render() {
    return (
      <div>
        {/* <Row className="mt-2 align-items-center conti-title">
          <Col className="col-auto pr-0">
            <h2 className="color-blue-3 font-20 mb-0">Participants</h2>
          </Col>         
        </Row> */}
        {/* <Row className="mt-2 align-items-center conti-title">
          <Col className="col-auto pr-0">
            <h2 className="color-blue-3 font-20 mb-0">Contingencies</h2>
          </Col>         
        </Row> */}
        {this.state.showLoader === true ?
          <div className="page-loader">
            <div className="page-loader-inner">
              <div className="spinner-border" role="status">
                <span className="sr-only">Loading...</span>
              </div>
            </div>
          </div>
          : ""
        }
        {this.renderMasterTemplateCamp()}

      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    allContingencies: state.reducer.allContingencies,   
  };
};

export default connect(mapStateToProps, {
  getAllContigencyAction,
})(Contingencies);